var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoaderVisible },
        on: {
          "update:active": function($event) {
            _vm.isLoaderVisible = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.has("branchId") }
        },
        [
          _c(
            "label",
            {
              staticClass: "col-sm-2 control-label",
              attrs: { for: "branchId" }
            },
            [_vm._v("Branch:")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _c("branch-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: { name: "branchId", "is-outlook": _vm.isOutlook },
                model: {
                  value: _vm.timeEntry.branchId,
                  callback: function($$v) {
                    _vm.$set(_vm.timeEntry, "branchId", $$v)
                  },
                  expression: "timeEntry.branchId"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("branchId")
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("branchId")))
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: {
            "has-error": _vm.errors.has("fileId") || _vm.fileIdErrorMessage
          }
        },
        [
          _c(
            "label",
            { staticClass: "col-sm-2 control-label", attrs: { for: "fileId" } },
            [_vm._v("KA Claim #:")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disable: true }
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.timeEntry.fileId,
                  expression: "timeEntry.fileId"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "fileId",
                name: "fileId",
                "data-vv-as": "KA Claim #",
                placeholder: "Enter the KA claim number this T&E entry is for."
              },
              domProps: { value: _vm.timeEntry.fileId },
              on: {
                blur: _vm.getFile,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.timeEntry, "fileId", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("fileId")
              ? _c("p", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.errors.first("fileId")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.fileIdErrorMessage && !_vm.errors.has("fileId")
              ? _c("p", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.fileIdErrorMessage))
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "label",
          { staticClass: "col-sm-2 control-label", attrs: { for: "fileId" } },
          [_vm._v("Insured:")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4" }, [
          _c("span", { staticClass: "insured-company" }, [
            _vm._v(_vm._s(_vm.timeEntry.insuredCompany))
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fa0a65e", { render: render, staticRenderFns: staticRenderFns })
  }
}